
export type UpdateUser500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
